export enum EventCategory {
  'Party' = 1,
  'Concert',
  'Performance',
  'Show',
  'Stand up',
  'Live music' ,
  'Other',
	// Hidden categories
	// '' = 999 || 998,
	'' = 999,
}

export enum TicketsStatus {
  'RESERVED' = 1,
  'PURCHASED',
  'REDEEMED',
  'REFUNDED',
  'CANCELED',
  'PENDING_PAYMENT' ,
  'FAILED_PAY',
  'FAILED_REDEEM',
  'FAILED_REFUND',
  'PENDING_REFUND',
}

export enum OrderStatus {
	'PENDING' = 1,
	'PURCHASED',
	'CANCELED',
	'FAILED_PAY',
	'REFUNDED',
	'PARTIALLY_PAID' ,
	'FAILED_CANCEL',
}

export enum TicketsUIStatus {
  'REDEEMED'= 3,
  'REFUNDED',
  'CANCELED',
}

export enum TicketsUIStatusColor {
  'REDEEMED'= 'green',
  'REFUNDED' = 'blue',
  'CANCELED' = 'purple',
  'EXPIRED' = 'red',
}

export enum EventStatus {
  DRAFT = 1,
  ACTIVE,
  CANCELED,
  PAST,
}

export enum PAYMENT_PROVIDER_ENUM {
  BRAIN_TREE = 1,
  MAGENSA = 2,
}

export enum WebsocketEventTypes {
  'TAB_CREATED' = 1,
  'PAYMENT_SUCCESS',
  'PAYMENT_FAILED',
  'TAB_FAILED',
  'TAB_CHANGED',
  'CLOSED_AUTO_CLOSEOUT',
  'EMAIL_CONFIRMATION',
  'TICKET_ORDER_PAID_SUCCESS' ,
  'TICKET_ORDER_PAID_FAILED',
  'TICKET_ORDER_PARTIAL_PAYMENT',
  'EVENT_TICKET_UPDATED'
}

export enum WebsocketStringMessageEnum {
  ping = '_ping',
  pong = '_pong',
}

export enum KeysCodes {
  backSpace = 8,
  deleteKey = 46,
}

export enum PaymentProvider {
  MAGENSA = 2
}

export enum PaymentTypes {
  google = 'google',
  apple = 'apple',
  reserveAndPurchase = 'reserve-and-purchase'
}

export enum CardTypes {
  americanexpress = 0,
  discover ,
  visa,
  mastercard,
}

export enum PRODUCT_ORDER_TYPES_ENUM {
  'For Here' = 1,
  'To Go',
  'Pickup'
}

export enum ORDER_TYPES_ENUM {
  isInVenue = 1,
  isPickUp = 3,
}

export enum CART_STATUSES_ENUM {
  NEW = 1,
  TAB_CREATED = 2,
  PAYMENT_IN_PROGRESS = 3,
  PAYMENT_FAILED = 4,
  PAYMENT_SUCCESS = 5,
  RECEIPT_VIEWED = 6,
  CLOSED_AUTO_CLOSEOUT = 7,
  WAITING_POS = 21
}

export const EXPIRED_STATUS = 'EXPIRED'

export enum ValidationMessageEnum {
  TICKET_ORDER_NOT_FOUND = 45001,
  TICKET_ORDER_PAYMENT_NOT_IN_PROGRESS = 45002,
  TICKET_ORDER_PAYMENT_IN_PROGRESS = 45003,
  TICKET_ORDER_RESERVED = 45004,
  TICKET_ORDER_PAID = 45005,
  TICKET_ORDER_NOT_PURCHASED = 45006,
  EVENT_NOT_FOUND = 45007,
  EVENT_STATUS_NOT_ACTIVE = 45008,
  USER_NOT_FOUND = 45009,
  VENUE_NOT_FOUND = 45010,
  VENUE_NOT_SUPPORT_PICKUP = 45011,
  VENUE_NOT_SUPPORT_TO_GO = 45012,
  CREDIT_CARD_NOT_FOUND = 45013,
  CREDIT_CARD_REACHED_MAXIMUM_LIMIT = 45014,
  CREDIT_CARD_NOT_VALID = 45015,
  CREDIT_CARD_NOT_VALID_EXP_DATE = 45016,
  CART_NOT_FOUND = 45017,
  CART_ALREADY_WAS_UPDATED = 45018,
  CART_EXPIRED = 45019,
  CART_SENT_TO_TAB = 45020,
  CART_NOT_ACTIVE = 45021,
  CART_UTENSILS_IN_ORDER = 45022,
  PRODUCT_NOT_FOUND = 45023,
  PRODUCTS_NOT_DELETED = 45024,
  CART_ITEM_SENT_TO_TAB = 45025,
  CART_ITEM_CART_NOT_ACTIVE = 45026,
  UTENSILS_CAN_INCLUDED = 45027,
  UTENSILS_NOT_AVAILABLE_FOR_TO_GO = 45028,
  UTENSILS_NOT_AVAILABLE_FOR_PICKUP = 45029,
  QR_CODE_NOT_FOUND = 45030,
  PHONE_CONFIRMED = 45031,
  PHONE_NOT_CONFIRMED = 45032,
  TICKETS_NOT_FOUND = 45033,
  LOCATION_REQUIRED_TO_MAKE_ORDER = 45034,
  PHONE_NUMBER_REQUIRED_TO_PICKUP = 45035,
  CUSTOMER_NAME_REQUIRED_TO_PICKUP = 45036,
  PICKUP_TIME_REQUIRED = 45037,
  PICKUP_TIME_NOT_UPDATED = 45038,
  PHONE_NUMBER_REQUIRED_TO_ORDERS = 45039,
  EMAIL_REQUIRED_TO_ORDERS = 45040,
  REQUEST_TO_OPEN_TAB_ALREADY_SENT = 45041,
  VENUE_NOT_SUPPORT_ACCEPTING_ONLINE_ORDERS = 45042,
  CART_ONE_OR_MORE_MODIFIERS_ARE_INVALID = 45043,
  CART_PRODUCT_NOT_HAVE_MODIFIERS = 45044,
  CART_PRODUCT_SOLD_OUT = 45045,
  CART_PRODUCT_NOT_HAVE_FORCED_MODS = 45046,
  CART_ONE_OR_MORE_FORCED_MODS_NOT_BELONG_TO_MOD_GROUP = 45047,
  CART_FORCED_MODS_CHOSEN_INCORRECTLY = 45048,
  CART_ITEM_INVALID = 45049,
  CART_NOT_POSSIBLE_TO_EDIT_ORDER = 45050,
  CART_FOR_HERE_NOT_AVAILABLE = 45051,
  CART_TO_GO_NOT_POSSIBLE = 45052,
  CART_DINE_IN_NOT_AVAILABLE = 45053,
  CART_PICKUP_NOT_POSSIBLE = 45054,
  CART_ORDER_HAS_AT_LIST_ONE_FOOD = 45055,
  CART_ORDER_HAS_AT_LIST_ONE_DRINK = 45056,
  QUANTITY_UNAVAILABLE_TRY_AGAIN_LATER = 4021,
  ALL_AVAILABLE_TICKETS_FOR_ACCOUNT = 4045
}

export const VALIDATION_EXP_CARD_DATE_VALIDATION_CODES = [
  ValidationMessageEnum.CREDIT_CARD_REACHED_MAXIMUM_LIMIT,
  ValidationMessageEnum.CREDIT_CARD_NOT_VALID,
  ValidationMessageEnum.CREDIT_CARD_NOT_VALID_EXP_DATE
]

export const RESERVATION_TICKET_VALIDATION_CODES_TS = [
  ValidationMessageEnum.TICKET_ORDER_RESERVED,
  ValidationMessageEnum.EVENT_STATUS_NOT_ACTIVE,
  ValidationMessageEnum.PHONE_NOT_CONFIRMED
]

export const PURCHASE_TICKET_VALIDATION_CODES_TS = [
  ValidationMessageEnum.TICKET_ORDER_PAYMENT_NOT_IN_PROGRESS,
  ValidationMessageEnum.EVENT_STATUS_NOT_ACTIVE
]

export const TICKETS_QUANTITY_UNAVAILABLE = [
  ValidationMessageEnum.ALL_AVAILABLE_TICKETS_FOR_ACCOUNT,
  ValidationMessageEnum.QUANTITY_UNAVAILABLE_TRY_AGAIN_LATER
]

export enum FailedPaymentTicketingEnum {
  GENERAL_FAIL_CASE = 1,
  INSUFFICIENT_FUNDS = 2,
  EXPIRED_CARD = 3,
  GENERAL_FAIL_CASE_TOKEN = 20,
  TOKEN_EXPIRED = 21,
  ACTION_REQUEST_WAS_NOT_PROCESSED = 203,
}

export const PAYMENT_FAILED_CODES_TICKETING = [
  FailedPaymentTicketingEnum.INSUFFICIENT_FUNDS,
  FailedPaymentTicketingEnum.EXPIRED_CARD,
  FailedPaymentTicketingEnum.GENERAL_FAIL_CASE_TOKEN,
  FailedPaymentTicketingEnum.TOKEN_EXPIRED,
]

export const PAYMENT_SERVICE_ERRORS_CODES_TICKETING = [
  FailedPaymentTicketingEnum.GENERAL_FAIL_CASE,
  FailedPaymentTicketingEnum.ACTION_REQUEST_WAS_NOT_PROCESSED,
]
